import '.ds{line-height:var(--line-height-body);}.ssr-plugin'
import '.ba{margin-top:0px;}.ssr-plugin'
import '.dr{margin-bottom:1.5rem;}.ssr-plugin'
import { styled, Style } from 'inlines'

interface OrderedListProps extends React.HTMLAttributes<HTMLOListElement> {
  style?: Style
}

export const OrderedList = ({ children, style, ...rest }: OrderedListProps) => {
  return (
    <styled.ol className="ds ba dr"
      {...rest}
      style={{
        '& > li': { marginTop: 0, marginBottom: '1rem' },
        ...style,
      }}
    >
      {children}
    </styled.ol>
  )
}
